import { render, staticRenderFns } from "./KCard.vue?vue&type=template&id=4d982e3f&scoped=true"
import script from "./KCard.vue?vue&type=script&lang=js"
export * from "./KCard.vue?vue&type=script&lang=js"
import style0 from "./KCard.vue?vue&type=style&index=0&id=4d982e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d982e3f",
  null
  
)

export default component.exports